import { LuCamera, LuVideo } from "react-icons/lu"
import { Link } from "@tanstack/react-router"
import { useSetAtom } from "jotai"
import { canWriteTo } from "@apps/gwservice/user-roles"
import { Avatar } from "~/components/ui/avatar"
import { RelativeTime } from "~/components/ui/relative-time"
import { plansDrawerOpenAtom } from "~/features/plans/atoms/plans-drawer"
import { useUser as useCurrentUser } from "~/features/profile/hooks/use-user"
import type { Chat } from "@apps/gwservice/types"

function MessagePreview({ lastMessage }: { lastMessage: Chat["lastMessage"] }) {
  const { text, media } = lastMessage ?? {}
  const isVideo = media?.mimeType?.startsWith("video")
  const isImage = media?.mimeType?.startsWith("image")

  return (
    <div className="text-sm text-muted-foreground flex items-center gap-1 min-w-0">
      {isVideo && <LuVideo className="size-icon-s shrink-0" />}
      {isImage && <LuCamera className="size-icon-s shrink-0" />}
      <span className="truncate">{text ?? (isVideo ? "Видео" : isImage ? "Фото" : "<нет сообщений>")}</span>
    </div>
  )
}

interface ChatListItemProps {
  chat: Chat
}

export function ChatListItem({ chat }: ChatListItemProps) {
  const { data: currentUser } = useCurrentUser()
  const openPlans = useSetAtom(plansDrawerOpenAtom)
  const lastMsg = chat.lastMessage
  const body = (
    <>
      <Avatar
        url={chat.peer.avatar?.url}
        name={chat.peer.name}
        variant={chat.peer.type === "groups" ? "group" : "user"}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-s">
          <span className="font-semibold truncate">{chat.peer.id === undefined ? "<УДАЛЕНО>" : chat.peer.name ?? "<Без имени>"}</span>
          {lastMsg && <RelativeTime date={lastMsg.createdAt} className="text-xs text-muted-foreground shrink-0" />}
        </div>
        <div className="flex items-center justify-between gap-s">
          <MessagePreview lastMessage={lastMsg} />
          {!!chat.unreadCount && (
            <span className="bg-primary text-primary-foreground text-xs rounded-full px-1.5 min-w-5 text-center shrink-0">
              {chat.unreadCount > 99 ? "99+" : chat.unreadCount}
            </span>
          )}
        </div>
      </div>
    </>
  )
  const className = "flex items-start gap-s px-m py-s hover:bg-muted/50"
  if (chat.peer.id === undefined) return <div className={className}>{body}</div>
  if (chat.peer.type === "users" && !canWriteTo(currentUser, chat.peer)) {
    return (
      <button type="button" onClick={() => openPlans("expertDm")} className={`${className} w-full text-left`}>
        {body}
      </button>
    )
  }
  return (
    <Link to="/chat" search={{ peerId: chat.peer.id, peerType: chat.peer.type }} className={className}>
      {body}
    </Link>
  )
}
